import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';
/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';

import { CheckBox } from 'Components';
import PropTypes from 'prop-types';

import PowerTableTrLeft from '../PowerTableTrLeft/PowerTableTrLeft';
import './PowerTableLeft.css';

const PowerTableLeft = (props) => {
  const { deletionState, dispatch } = useContext(DeletionContext);

  const tempListOfRowsAllowedForDeletion = [];

  const hasPins = ['templates', 'overviewTemplates', 'supplies', 'orders', 'overviewOrders'].includes(props.code);
  const hasLocks = props.data.some((x) => x.LockTemplate);
  const hasDocs = ['submittedTab', 'receivedJobs', 'additionTab'].includes(props.viewCode);

  return (
    <div className="power-table-left">
      <div className="power-table-left__inner">
        <div className="power-table-left__body" ref={props.leftRef}>
          {props.data.map((row, i) => {
            return (
              <PowerTableTrLeft
                {...row}
                code={props.code}
                onPinClick={() => props.onPinClick(i, props.viewCode)}
                onDocumentClick={(e) => props.onDocumentClick(e, i)}
                onOptionClick={props.onOptionClick}
                popoverRef={props.popoverRef}
                popoverRow={props.popoverRow}
                isDocMenuActive={i === props.popoverRow}
                hasPins={hasPins}
                hasLocks={hasLocks}
                hasDocs={hasDocs}
                i={i}
                key={i}
                leftDocumentPopover={props.renderLeftDocumentPopover ? props.renderLeftDocumentPopover(row) : null}
              />
            );
          })}
        </div>

        <div className="power-table-left__head" style={{ width: `${props.leftOffset}px` }} />

        {deletionState.isDeletionModeActive ? (
          <div className="power-table-left__head">
            <div>
              <CheckBox
                checked={deletionState.isCheckedAll}
                onClick={() => {
                  dispatch({
                    type: DELETE_ACTIONS.TOGGLE_CHECK_ALL_ALLOWED_ITEMS,
                  });
                }}
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

PowerTableLeft.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  leftRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  onPinClick: PropTypes.func,
  code: PropTypes.string,
  viewCode: PropTypes.string,
  onDocumentClick: PropTypes.func,
  popoverRow: PropTypes.number,
  popoverRef: PropTypes.shape({}),
  leftOffset: PropTypes.number,
  onOptionClick: PropTypes.func,
  renderLeftDocumentPopover: PropTypes.func,
};

export default PowerTableLeft;



// WEBPACK FOOTER //
// ./src/components/PowerTable/PowerTableLeft/PowerTableLeft.jsx